<template>
  <div class="modalPrimary modal-sm" :class="{active: this.$store.state.main.modalShow}">
    <button class="close max-md-hidden" @click="closeModal">x</button>
    <div class="modalBox text-center">
      <button class="close md-hidden" @click="closeModal">x</button>

      <p class="fs-36" v-if="title">{{ title }}</p>
      <p v-if="type === 'text'" v-html="text"></p>
      <ul v-if="type === 'list'" class="modalBox__list">
        <li v-for="(item, index) in text" :key="index">
          {{ item }}
        </li>
      </ul>

      <button class="btn btn-green w-100" type="button" @click.prevent="closeModal">
        {{ okBtnText }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MainModal",
  computed: {
    ...mapGetters({
      'show': 'modalShow'
    }),
    modalType() {
      return this.$store.state.main.modalType
    },
    text() {
      if (this.type === 'list') {
        return this.$store.state.main.modalContent.split("\n")
      }
      return this.$store.state.main.modalContent
    },
    title() {
      return this.$store.state.main.modalTitle
    },
    okBtnText() {
      return this.$store.state.main['okBtnText'] || 'Ok, I understand'
    },
    type() {
      return this.$store.state.main.modalType
    },
    callback() {
      return this.$store.state.main.modalCallback
    }
  },
  methods: {
    closeModal() {
      var callback = this.callback;

      this.$store.commit('changeModalStatus', false)
      this.$store.commit('changeModalCallback', null)

      if (callback) {
        callback();
      }
    },
  },
  watch: {
    show(value) {
      if (value) {
        document.getElementsByTagName('body')[0].classList.add('vh100')
      } else {
        document.getElementsByTagName('body')[0].classList.remove('vh100')
      }
    },
  }
}
</script>

<style>
.mb-custom {
  margin-top: 50px !important;
  margin-bottom: 70px !important;
}
.max-md-hidden{
  @media (max-width: 767px) {
    display: none;
  }
}
.md-hidden{
  @media (min-width: 768px) {
    display: none;
  }
}
</style>
